module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "pgepubid00000"
    }
  }, [_c('h1', [_c('i', [_vm._v("The")]), _c('br'), _vm._v("\nMOVING FINGER")])]), _vm._v(" "), _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "poetry-container"
  }, [_c('div', {
    staticClass: "poetry"
  }, [_c('div', {
    staticClass: "bbox"
  }, [_c('p', {
    staticClass: "ph1"
  }, [_vm._v("By NATALIE SUMNER LINCOLN")]), _vm._v(" "), _c('hr', {
    staticClass: "tiny"
  }), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', [_vm._v("The Moving Finger")]), _vm._v(" "), _c('td', [_vm._v("I Spy")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("The Nameless Man")]), _vm._v(" "), _c('td', [_vm._v("C. O. D.")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("The Official Chaperon     ")]), _vm._v(" "), _c('td', [_vm._v("The Man Inside")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("The Lost Despatch")]), _vm._v(" "), _c('td', [_vm._v("The Trevor Case")])])])]), _vm._v(" "), _c('hr', {
    staticClass: "full"
  }), _vm._v(" "), _c('p', [_vm._v("D. APPLETON & COMPANY, NEW YORK")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e53d119","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/3186253215635795556_74210-h-1.htm.vue
// module id = 60
// module chunks = 0